import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import { injectIntl } from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class ScoreByDeviceBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const scoreByDevice = answersReport ? answersReport.scoreByDevice : [];

    const categories = scoreByDevice.map(item => item.device);
    const data = scoreByDevice.map(item => item.score);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height - (styles.wrapper.padding * 2),
        width: this.props.width - (styles.wrapper.padding * 2),
      },
      title: {
        text: intl.formatMessage({ id: 'score' }),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function () {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          }, {
            count: scoreByDevice[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{ id: this.props.uniqueId }}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(ScoreByDeviceBarChart),
  graphql`
    fragment ScoreByDeviceBarChart_answersReport on AnswersReport {
      scoreByDevice {
        device
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceBarChart/ScoreByDeviceBarChart.js